type WindowWithDataLayer = Window & {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dataLayer: Record<string, any>[];
};

declare const window: WindowWithDataLayer;

export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;
export const GTM_AUTH = process.env.NEXT_PUBLIC_GTM_AUTH;
export const GTM_PREVIEW = process.env.NEXT_PUBLIC_GTM_PREVIEW;

export enum TRACKING_EVENT {
    PRESSED_BUTTON = 'Pressed Button',
    TOGGLED_FAQ = 'Toggled FAQ Accordion',
    PLAYED_VIDEO = 'Played Video',
    PAUSED_VIDEO = 'Paused Video',
    CONTACT_LINK = 'Pressed Contact Link',
}

type VideoTracking = {
    title: string;
    videoId: string;
    page?: string;
    views?: number;
    duration?: number;
};

/**
 * Properties corresponding to each event
 */
export type EventProperties = {
    [TRACKING_EVENT.PRESSED_BUTTON]: {
        label: string;
        /**
         * Category is optional, but if it is not provided, the event will not be tracked
         */
        category?: string;
        url?: object | string;
        page?: string;
    };
    [TRACKING_EVENT.TOGGLED_FAQ]: {
        faqQuestion: string;
        page?: string;
    };
    [TRACKING_EVENT.PLAYED_VIDEO]: VideoTracking;
    [TRACKING_EVENT.PAUSED_VIDEO]: VideoTracking;
    [TRACKING_EVENT.CONTACT_LINK]: {
        page?: string;
        label?: string;
        link?: string;
    };
};

export const pageview = (url: string) => {
    if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({
            event: 'pageview',
            page: url,
        });
    } else {
        console.log({
            event: 'pageview',
            page: url,
        });
    }
};

/**
 * Send an event to Segment. Params are typed to ensure that the correct params are passed for each event.
 * @param event
 * @param params
 */
export const track = <T extends keyof EventProperties>(event: T, params: EventProperties[T]) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event,
        ...params,
    });
};
